import React, { PureComponent } from "react";
import PT from "prop-types";
import * as S from "./styled";
import isempty from "lodash/isEmpty";
import NoItemsPlaceholder from "./EmptyPlaceholder";
import Slide from "./Slide";
import LoadPhotoButton from "./LoadButton";
import loadable from "@loadable/component";
import SectHeader from "_c/modules/profile/common/SectHeader";
import { withTranslation } from "react-i18next";
import { analyticsAction } from "@/utils/analytics";
import UploadForm from "./UploadForm";
const PhotoViewer = loadable(() => import("_c/photo-viewer/modal"));

class PortfolioSlider extends PureComponent {
  state = {
    uploadOpen: false,
  };
  onSubmit = async ({ service, photo, desc }) => {
    const { type, uploaderId } = this.props;
    await this.props.addPortfolio({
      photo,
      as: type,
      [type]: uploaderId,
      service,
      desc,
    });
  };
  toggleForm = () => {
    if (!this.state.uploadOpen) {
      analyticsAction({
        category: "profile",
        action: "photo_click",
      });
    }
    this.setState({
      uploadOpen: !this.state.uploadOpen,
    });
  };
  render() {
    const {
      items,
      isOwner,
      favorites,
      isAuth,
      toggleLike,
      type,
      removePortfolio,
      addPortfolio,
      t,
    } = this.props;
    const hasPhotos = !isempty(items);
    if (!this.props.tReady) return null;
    if (!hasPhotos && !isOwner) return null;
    return (
      <S.Wrap id="profile-portfolio-container">
        {hasPhotos && (
          <PhotoViewer
            t={t}
            authUserId={this.props.authUserId}
            addComment={this.props.addComment}
            removeComment={this.props.removeComment}
            toggleLike={toggleLike}
            onClose={this.props.closeGallery}
            openShareModal={this.props.openShareModal}
            favorites={favorites}
            isOpen={this.props.isGalleryOpen && this.props.galleryIdx !== null}
            active={this.props.galleryIdx}
            slides={items}
          />
        )}
        {type === "master" && (
          <SectHeader>
            {t(`common:portfolio.master_head_${isOwner ? "owner" : "guest"}`)}
          </SectHeader>
        )}
        {!hasPhotos && <NoItemsPlaceholder />}
        {hasPhotos && (
          <S.SliderWrap>
            {items.map((item, i) => (
              <Slide
                t={t}
                index={i}
                isFavorite={favorites.includes(item._id)}
                toggleLike={toggleLike}
                key={item._id}
                slide={item}
                isAuth={isAuth}
                openShareModal={this.props.openShareModal}
                upload={addPortfolio}
                remove={removePortfolio}
                isOwner={isOwner}
                type={type}
                openGallery={this.props.openGallery}
                defaultAltText={this.props.defaultSlideAltText}
              />
            ))}
          </S.SliderWrap>
        )}
        {isOwner && (
          <>
            <LoadPhotoButton
              isOpen={this.state.uploadOpen}
              t={t}
              toggleForm={this.toggleForm}
              type={type}
            />
            <UploadForm
              t={t}
              isOpen={this.state.uploadOpen}
              onSubmit={this.onSubmit}
              services={this.props.services}
              type={type}
              showServiceSelect={type === "master"}
              onClose={this.toggleForm}
            />
          </>
        )}
      </S.Wrap>
    );
  }
}
PortfolioSlider.propTypes = {
  loading: PT.bool,
  items: PT.array,
  isOwner: PT.bool,
  type: PT.oneOf(["client", "master", "saloon"]),
  favorites: PT.array,
  uploaderId: PT.string,
  authUserId: PT.string,
  services: PT.array,
  isGalleryOpen: PT.bool,
  galleryIdx: PT.number,
  tReady: PT.bool,
  defaultSlideAltText: PT.string,

  t: PT.func.isRequired,
  toggleLike: PT.func.isRequired,
  addPortfolio: PT.func.isRequired,
  removePortfolio: PT.func.isRequired,
  addComment: PT.func.isRequired,
  removeComment: PT.func.isRequired,
  openGallery: PT.func.isRequired,
  closeGallery: PT.func.isRequired,
  openShareModal: PT.func.isRequired,
};
const WithTrans = withTranslation(["common", "errors"])(PortfolioSlider);
WithTrans.defaultProps = {
  useSuspense: false,
};

export default WithTrans;
